/* eslint-disable jsx-a11y/label-has-associated-control,jsx-a11y/label-has-for,jsx-a11y/anchor-has-content */

import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import forEach from 'lodash/forEach';


import DrawingCanvas from '../DrawingCanvas';
import LinearLoader from '../linearLoader';
import { visualConversationStore } from '../../utils/vcUtils';

import './index.scss';

function mapStateToProps(state, { vcId, selectedId, ...rest }) {
  const vcData = state[visualConversationStore(vcId)];
  const activeBranchData = vcData.get('activeBranchData').toJS();

  const imageTrail = [];
  forEach(activeBranchData, (data) => {
    if (data.id === selectedId) {
      imageTrail.push(data.src);
      return false;
    }
    imageTrail.push(data.src);
    return true;
  });

  return {
    ...rest,
    imageTrail,
  };
}

class ReplyDrawingCanvas extends PureComponent {
  constructor(props) {
    super(props);
    this.slider = React.createRef();
    this.scrollToRight = this.scrollToRight.bind(this);
  }

  componentDidMount() {
    const { onSuccessfulMount } = this.props;
    onSuccessfulMount();
    this.scrollToRight();
  }

  scrollToRight() {
    this.slider.current.scrollLeft = this.slider.current.scrollWidth;
  }

  render() {
    const {
      disableSaveDraft, children, onSaveDraftClick, showLoader, imageTrail,
    } = this.props;

    return (
      <DrawingCanvas>
        <div className="customDrawingCanvasLib">
          <section className="overlay-conversation-modal">
            <article className="overlay-modal-in">
              <section className="horscroll_modal scrollarea">
                <div className="railarea modalConversationSketchpad" ref={this.slider}>
                  <div className="canvasImages">
                    {imageTrail.map(src => (<img src={src} alt="" key={src} />)) }
                  </div>
                  <div className="content-base type-height-middle3">
                    <div className="canvasLoader">
                      { showLoader
                      && <LinearLoader scope="drawingCanvas" />}
                    </div>
                    <div className="secc-sketchpad the-content">
                      <div className="secc-sketchpad-in toolbox-cont">
                        <div className="interactionBox sketchpad-area">
                          <div className="sketchpad-box">
                            <div id="sketchpad_container">
                              <div className="span" id="all_canvas_container">
                                <div id="dummyCanvasContainer">
                                  <div id="background_dummy_canvas_container" />
                                </div>
                                <div className="hide" id="canvasContainer_final" />
                                <div id="canvasContainer" />
                                <div className="hide" id="canvasBlankContainer" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <Draggable
                      axis="both"
                      cancel="#alpha_slider, #brush_size_slider"
                    >
                      <div className="middle3 toolbox-area">
                        <div className="toggleToolboxBtn">
                          <i className="fa fa-minus" />
                        </div>
                        <div className="toolbox-area-in">
                          <div className="toolbox-cover">
                            <div className="toolbox">
                              <div className="tool-icons" id="toolBox">
                                <ul>
                                  <li className="pencil_li toolbox_click">
                                    {/* toolbox_click pencilBtn */}
                                    <div
                                      className="button button-pen stroke-tool"
                                      id="pencil"
                                      onClick={() => window.dadaCanvas.setBrushType('pencil')}
                                      role="button"
                                      tabIndex={0}
                                    >
                                      <figure className="icon pencil" />
                                    </div>
                                  </li>
                                  <li
                                    className="round_brush_li toolbox_click"
                                  >
                                    {/* toolbox_click brushBtn */}
                                    <div
                                      className="button button-pen stroke-tool down"
                                      id="round_brush"
                                      onClick={() => window.dadaCanvas.setBrushType('round_brush')}
                                      role="button"
                                      tabIndex={0}
                                    >
                                      <figure className="icon brush" />
                                    </div>
                                  </li>
                                  <li className="marker_li toolbox_click">
                                    {/* toolbox_click highlightBtn */}
                                    <div
                                      className="button button-pen stroke-tool"
                                      id="marker"
                                      onClick={() => window.dadaCanvas.setBrushType('marker')}
                                      role="button"
                                      tabIndex={0}
                                    >
                                      <figure className="icon highlight" />
                                    </div>
                                  </li>
                                  <li className="eraser_li toolbox_click">
                                    {/* toolbox_click eraserBtn */}
                                    <div
                                      className="button button-eraser stroke-tool"
                                      id="eraser"
                                      onClick={() => window.dadaCanvas.setBrushType('eraser')}
                                      role="button"
                                      tabIndex={0}
                                    >
                                      <figure className="icon eraser" />
                                    </div>
                                  </li>
                                  <div className="brush_size_slider">
                                    <div className="brush_size_slider_in">
                                      {/* brush_size_slider_in hidden */}
                                      <i className="close_slider fa fa-times" />
                                      <label
                                        className="btn btn-default btn-sm hide tooltip_target"
                                        data-placement="bottom"
                                        data-title="Brush size"
                                        data-toggle="span"
                                        disabled="disabled"
                                        href="#"
                                        id="show_brush_size_slider"
                                      >
                                        <span id="amount">1</span>
                                      </label>
                                      <div
                                        className="bottom fade in"
                                        id="brush_size_slider_container"
                                        style={{ position: 'absolute', zIndex: 2 }}
                                      >
                                        <div
                                          aria-disabled="false"
                                          className="ui-slider ui-slider-vertical
                                          ui-widget ui-widget-content ui-corner-all"
                                          id="brush_size_slider"
                                        >
                                          <div
                                            className="ui-slider-range ui-widget-header
                                            ui-corner-all ui-slider-range-min"
                                            style={{ height: '0%' }}
                                          />
                                          <a
                                            className="ui-slider-handle ui-state-default ui-corner-all"
                                            style={{ bottom: '0%' }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <li className="go_back_li">
                                    {/* undoBtn */}
                                    <div className="button button-undo" id="btn_undo">
                                      <figure className="icon goBack" />
                                    </div>
                                  </li>
                                  <li className="go_forward_li">
                                    {/* redoBtn  */}
                                    <div className="button button-redo" disabled="disabled" id="btn_redo">
                                      <figure className="icon goForward" />
                                    </div>
                                  </li>
                                </ul>
                              </div>
                              <div className="main-alpha-tool">
                                <div className="alpha-spinner-container input-group">
                                  <input className="form-control" id="alpha_box" value="100" />
                                </div>
                                <div className="alpha_slider">
                                  <div className="alpha_slider_in hidden">
                                    <i className="fa fa-times close_alpha_slider" />
                                    <label
                                      className="btn btn-sm btn-white tooltip_target hidden"
                                      id="show_alpha_slider"
                                    >
                                      <span id="alpha_amount" />
                                    </label>
                                    <div className="fade bottom in" id="alpha_slider_container">
                                      <div id="alpha_slider" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="color-picker">
                                <input
                                  className="color-frame color1 hidden"
                                  id="color_picker"
                                  style={{ display: 'none' }}
                                  type="text"
                                  value="#000000"
                                />
                                <input
                                  className="color-frame color2 hidden"
                                  id="bg_color_picker"
                                  style={{ display: 'none' }}
                                  type="text"
                                  value="#ffffff"
                                />
                              </div>
                              <div className="clear-button">
                                <div
                                  className="btn btn-block btn-sm btn-white"
                                  data-placement="bottom"
                                  data-title="Clear"
                                  onClick={() => window.dadaCanvas.erase(true)}
                                  role="button"
                                  tabIndex={0}
                                >
                                  <figure className="toTrash" />
                                </div>
                              </div>
                            </div>
                            <div className="hintSave hide">
                              <div className="savingHintTextHor">
                                <span className="saveText">save</span>
                                <span className="savingText hide">saving...</span>
                              </div>
                            </div>
                            <button
                              className="save-button-toolbox"
                              disabled={disableSaveDraft}
                              onClick={onSaveDraftClick}
                              type="button"
                            />
                            <div className="toolbox-bg-last" />
                          </div>
                        </div>
                      </div>
                    </Draggable>

                  </div>
                  { children }
                </div>
              </section>
            </article>
          </section>
        </div>
      </DrawingCanvas>
    );
  }
}

ReplyDrawingCanvas.propTypes = {
  disableSaveDraft: PropTypes.bool.isRequired,
  onSuccessfulMount: PropTypes.func.isRequired,
  onSaveDraftClick: PropTypes.func.isRequired,
  showLoader: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  vcId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  selectedId: PropTypes.number.isRequired,
};

export default connect(
  mapStateToProps,
)(ReplyDrawingCanvas);



// WEBPACK FOOTER //
// ./src/components/ReplyDrawingCanvas/index.js